import React, {useMemo, useState} from "react";
import {MobileNumberIcon} from "../Styled";
import {Button} from "../../../HTMLEntities/Button";

interface Props {
    setCurrentLoginLayer?: React.Dispatch<React.SetStateAction<string | "emailLoginLayer">>;
    setShowTabs?: React.Dispatch<React.SetStateAction<boolean | true>>;
}

const LoginWithMobile: React.FC<Props> = ({setCurrentLoginLayer, setShowTabs}: Props) => {
    const [showButton] = useState(true);
    const mobileJSX = useMemo(() => {
        return (
            <>
                {showButton && (
                    <Button
                        as="div"
                        blue
                        onClick={() => {
                            setCurrentLoginLayer && setCurrentLoginLayer("M1LoginLayer");
                            setShowTabs && setShowTabs(false);
                        }}
                    >
                        <MobileNumberIcon />
                        Login With Mobile No
                    </Button>
                )}
            </>
        );
    }, [setCurrentLoginLayer, setShowTabs, showButton]);

    return <>{mobileJSX}</>;
};

export default LoginWithMobile;
